import React from 'react';
import CustomTabs from '@/components/desktop/CustomTabs';
import SearchFlightTab from '@/containers/Desktop/SearchFlightTab/seo';
import { style } from '@/styles/globals';
import { pr } from '@/utils/pxToRem';
import BusIcon from '@mui/icons-material/DirectionsBus';
import FlightIcon from '@mui/icons-material/Flight';
import TrainIcon from '@mui/icons-material/Train';
import { Box, Grid, Typography } from '@mui/material';
import { styled } from '@mui/system';

import SearchBusTab from '@/containers/Bus/SearchBusTab/desktop';
import SearchTrainTab from '@/containers/SearchTrainTab/desktop';

interface ILandingPage{
  title?: string;
  firstInit?: boolean;
  closeFirstInit?: any;
  filterAirline?: any
}

const LandingPageSeo = (props: ILandingPage) => {
  const {
    title, firstInit, closeFirstInit, filterAirline,
  } = props;
  return (
    <Container sx={{
      height: {
        xs: '500px',
        lg: '374px',
      },
    }}
    >
      <ImageContainer />
      <LandingPageWrapper sx={{
        padding: {
          xs: '0 20px',
          md: '0 144px',
        },
      }}
      >
        <Grid
          position="relative"
          container
        >
          <Grid
            item
            sx={{
              mt: pr`32px`,
              mb: pr`32px`,
            }}
            xs={12}
          >
            <Typography
              component="h1"
              sx={{
                fontWeight: 500,
                fontSize: {
                  xs: pr`22`,
                  sm: pr`40px`,
                },
                lineHeight: {
                  xs: pr`28px`,
                  sm: pr`40px`,
                },
                p: {
                  xs: '0',
                  sm: '0 32px',
                },
                textAlign: {
                  xs: 'left',
                  sm: 'center',
                },
                color: style.color.white4,
              }}
            >
              { title || ' Đặt vé máy bay giá rẻ'}
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
          >
            <CustomTabs
              labelObjs={[
                {
                  type: 'flight',
                  icon: <FlightIcon />,
                },
                {
                  type: 'bus',
                  icon: <BusIcon />,
                },
                {
                  type: 'train',
                  icon: <TrainIcon />,
                },
              ]}
              tabComponent={[<SearchFlightTab
                firstInit={firstInit}
                filterAirline={filterAirline}
                closeFirstInit={closeFirstInit}
                key={1}
              />, <SearchBusTab
                key={2}
              />, <SearchTrainTab
                key={3}
              />]}
            />
          </Grid>
        </Grid>
      </LandingPageWrapper>
    </Container>
  );
};

const ImageContainer = styled(Box)`
  height: 100%;
  top: 0px;
  left: 0px;
  width: 100%;
  background: url("https://storage.googleapis.com/goyolo-production/desktop-cover.png")
    50% 50% / cover;
  position: absolute;
`;
const Container = styled(Box)`
  position: relative;
`;
const LandingPageWrapper = styled(Box)`
  position: relative;
`;

export default LandingPageSeo;
